import styled from 'styled-components'
import theme from 'theme_'
import { Icon } from '@mdi/react'
import { Font16 } from 'components/Typography'

export const HomeStatusLayout = styled.section`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  font-weight: normal;
  ${Font16};
  color: ${theme.colors.menuDark};
`

export const StyledIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const StyledIcoBasic = styled(Icon)`
  color: ${theme.colors.error};
  margin-right: 10px;
`

export const SubInfoBlackCardDate = styled.span`
  color: black;
`
